module.exports = __webpack_public_path__ + "static/media/nervous-3.9c5ab415.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/presentation/nervous-3.jpg
// module id = 338
// module chunks = 11